import { useTranslation } from 'react-i18next';

import { Input } from './ui/Input';

interface DateRangePickerProps {
  dateFrom?: string;
  onDateFromChange: (value: string | undefined) => void;
  error?: string;
  disabled?: boolean;
}

export function DateRangePicker({
  dateFrom,
  onDateFromChange,
  error,
  disabled = false,
}: DateRangePickerProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.DateRangePicker',
  });

  return (
    <div className="flex flex-col">
      <Input
        id="date-from"
        type="date"
        value={dateFrom || ''}
        onChange={(e) => onDateFromChange(e.target.value || undefined)}
        placeholder={t('dateFromPlaceholder')}
        disabled={disabled}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
